const pickString = (...values) => {
  for (const value of values) {
    const text = String(value ?? "").trim();
    if (text) return text;
  }
  return "";
};

/** Display label for the logged-in user's application/org role (not platform system role). */
export const resolveUserRoleLabel = (userData) => {
  if (!userData) return "User";

  if (typeof userData.role === "string") {
    const roleText = userData.role.trim();
    if (roleText) return roleText;
  }

  const fromRoleName = pickString(userData.role_name);
  if (fromRoleName) return fromRoleName;

  const fromRoleObject = pickString(
    userData?.role?.user_role_name,
    userData?.role?.role?.user_role_name
  );
  if (fromRoleObject) return fromRoleObject;

  const fromAssignment = pickString(
    userData?.organizationuser?.role_assignment?.application_user_role
      ?.user_role_name,
    userData?.organizationuser?.RoleAssignment?.ApplicationUserRole
      ?.user_role_name,
    userData?.role_assignment?.application_user_role?.user_role_name
  );
  if (fromAssignment) return fromAssignment;

  return "User";
};
